import { createContext, useContext, useState } from 'react';

const LayoutStatusContext = createContext();

export function LayoutStatusProvider({ children }) {
  const [statusMap, setStatusMap] = useState({});

  const updateStatus = (layoutId, status) => {
    setStatusMap(prev => ({
      ...prev,
      [layoutId]: status === 'disabled'
    }));
  };

  const getStatus = (layoutId, defaultStatus) => {
    return statusMap[layoutId] ?? (defaultStatus === 'disabled');
  };

  return (
    <LayoutStatusContext.Provider value={{ updateStatus, getStatus }}>
      {children}
    </LayoutStatusContext.Provider>
  );
}

export function useLayoutStatus() {
  const context = useContext(LayoutStatusContext);
  if (!context) {
    throw new Error('useLayoutStatus must be used within a LayoutStatusProvider');
  }
  return context;
}